
<section>
    <section class="row form-container w-185">
        <form *ngIf="!resetSuccessResponse?.message;else defaultmailTemplate" name="form" #forgotPasswordForm="ngForm"
        (ngSubmit)="onSubmit(false)" novalidate>
                <div class="flex w-full justify-start font-body mt-12 mb-16">
                    <a
                        class="text-primary-400 text-xs cursor-pointer flex"
                        (click)="goToLogin()">
                       <div class="chevron-left-blue mr-0.5x"></div> Back to login options
                    </a>
                </div>
                <div class="flex flex-col mb-5">
                    <div class="forgot-password mx-auto mb-3"></div>
                    <div class="flex flex-col items-center">
                      <div class="text-text-default text-6gpx font-body-semibold mb-0.2">We’ve Got You Covered!</div>
                      <div class="text-6gpx text-title-default">We’ll email you a link to reset your password.</div>
                    </div>
                  </div>
            <div class="animate-opacity form-container w-185 flex flex-col">
                <div class="form-group">
                    <label for="employeeNumber" class="mb-1 text-6gpx block text-title-default">Login ID</label>
                    <div class="mb-16 text-6gpx">
                        <input type="text"
                               class="form-control placeholder-gray-300 h-16 w-full text-text-default border border-solid rounded-gt-md-4 focus:outline-none text-7gpx p-3 font-body"
                               name="username"
                               id="username"
                               autocomplete="off"
                               placeholder="Employee Number"
                               [(ngModel)]="resetForm.username"
                               #username="ngModel"
                               (ngModelChange)="resetError=''"
                               [ngClass]="{'border-danger': resetError !== ''}"
                               required
                               autofocus
                               [autofocus]="true"
                        />
                        <div class="text-danger-400 text-xs mt-0.2" *ngIf="resetError !== ''">{{resetError}}</div>
                    </div>
                </div>
                <div class="flex w-full justify-center">
                    <button
                        class="bg-primary-400 h-12 items-center justify-center text-white flex w-96x text-7gpx font-body-semibold rounded-gt-md-3"
                        type="submit">
                        Send Link
                    </button>
                </div>
            </div>
        </form>
        <ng-template #defaultmailTemplate >
            <ng-container *ngIf="!isAlumni;else mailTemplate">
                <div class="flex flex-col mb-8 w-185 mt-30">
                    <div class="reset-send-link mx-auto mb-3"></div>
                    <div class="flex flex-col items-center mb-16">
                      <div class="text-text-default text-6gpx font-body-semibold mb-0.2">Reset link sent!</div>
                      <div class="text-6gpx text-title-default">We’ve sent the password reset link to registered email address</div>
                      <div class="text-6gpx text-title-default"> Please check your inbox.</div>
                    </div>
                    <div class="flex flex-col items-center">
                        <div class="flex w-full justify-center">
                            <button
                                class="bg-primary-400 h-12 items-center justify-center text-white flex text-7gpx w-120x text-body-semibold rounded-gt-md-3"
                                (click)="goToLogin()">
                                Back to Login
                            </button>
                        </div>
                        <div class="flex w-full justify-center mt-16">
                            <a
                                class="text-primary-400 text-6gpx cursor-pointer"
                                [href]="oAuthPath.NEED_HELP"
                                target="_blank"
                                rel="noopener noreferrer">
                                Still need help?
                            </a>
                        </div>
                    </div>
                  </div>
           </ng-container>
        </ng-template>

        <ng-template #mailTemplate let-showMailTemplate="!hasMobileNumber">
            <ng-container *ngIf="(isAlumni && resetSuccessResponse?.alumniPortalEnabled && (!!resetSuccessResponse.alternateEmail && !displayDefaultTemplate && !hasMobileNumber));else mobileTemplate">
            <div class="gt-mail-box"></div>
            <div class="mt-5 flex">
                <div class="flex flex-col p-5 rounded-gt-md-4 w-185 h-auto bg-std-success">
                    <div class="mb-1 opacity-90 text-7gpx font-semibold font-body-semibold text-text-default">
                        Woo-hoo. Well done!
                    </div>
                    <ng-container *ngIf="isAlumni">
                        <div class="opacity-90 text-7gpx text-text-default font-body">
                            You’ve got an email to reset your password
                        </div>
                        <div class="opacity-90 text-7gpx text-text-default font-body">
                            on {{ maskTheEmail(resetSuccessResponse?.alternateEmail) }}.
                        </div>
                        <div class="opacity-90 text-7gpx text-text-default font-body">
                            Let’s make it happen.
                        </div>
                        <div class="flex w-full justify-start mt-1">
                            <button (click)="goToLogin()"
                            class="mt-5 mb-5 bg-primary h-21 items-center justify-center text-white flex w-full text-7gpx font-semibold rounded-gt-md-3 font-body-semibold">
                            Back to Login
                        </button>
                        </div>
                    </ng-container>                    
                    <div class="flex w-full justify-end font-body" *ngIf="isAlumni">
                        <a  (click)="onCantAccessEmail()"
                            class="text-primary text-7gpx font-semibold font-body-semibold cursor-pointer">
                            I can't access to my email
                        </a>
                    </div>
                </div>
           </div>
           </ng-container>
        </ng-template>
        <ng-template #mobileTemplate>
            <div *ngIf="(isAlumni && resetSuccessResponse?.alumniPortalEnabled && !!resetSuccessResponse.alternateMobileNo && !displayDefaultTemplate);else displayTemplate" class="mt-5 flex">
                <div class="flex flex-col p-5 w-185 h-auto">
                    <div class="mb-1 opacity-90 text-7gpx font-semibold font-body-semibold text-text-default">
                        We've got you!
                    </div>
                    <div class="opacity-90 text-7gpx text-text-default font-body mb-2">
                        You've got an OTP on <span class="font-semibold font-body-semibold text-text-default">{{maskMobileNumber(resetSuccessResponse?.alternateMobileNo)}}.</span> 
                    </div>
                    <div>
                        <form name="form" #mobileOtpForm="ngForm" (ngSubmit)="onOtpSubmit()" novalidate>
                            <div class="mb-5">
                                <label for="otp" class="mb-2 block opacity-90 text-6gpx font-semibold font-body-semibold text-text-default">OTP<sup><span class="text-danger">*</span></sup></label>
                                <div class="text-6gpx">
                                    <input type="text" 
                                      class="form-control placeholder-gray-300 h-21 w-full text-text-default border border-solid rounded-gt-md-4 focus:outline-none text-7gpx p-3 font-medium font-body" 
                                      [placeholder]="'Enter the 6 digit OTP'"
                                      name="otp"
                                      id="otp"
                                      autocomplete="off"
                                      [(ngModel)]="otpForm.otp"
                                      (ngModelChange)="resetError=''"
                                      #otp="ngModel"
                                      required
                                      autofocus
                                      [autofocus]="true"
                                      [ngClass]="{'border-danger': otp.invalid && (otp.dirty || otp.touched)}"
                                      pattern="[0-9]{6}"
                                      (input)="invalidOtp = false"
                                      />
                                      <div class="row">
                                        <div class="col-md-6 pr-0">
                                            <div class="opacity-90 text-6gpx text-text-default font-body mb-1 text-danger" *ngIf="(otp.invalid && (otp.dirty || otp.touched)) && otp.errors.required">This field is required</div>
                                            <div *ngIf="((otp.invalid && (otp.dirty || otp.touched)) && otp.errors.pattern) || invalidOtp" class="opacity-90 text-6gpx text-text-default font-body mb-1 text-danger">
                                                Please enter correct OTP
                                            </div>
                                        </div>
                                        <div *ngIf="!showCountDown" class="col-md-6 mb-5 text-end">
                                            <a  (click)="onResendOtp()"
                                                class="text-primary text-7gpx font-semibold font-body-semibold cursor-pointer">
                                                Resend OTP
                                            </a>
                                          </div>
                                          <div *ngIf="showCountDown" class="col-md-6 mb-5 text-end">
                                            <span class="text-7gpx font-semibold font-body-semibold text-title-default mb-5">Resend OTP </span> &nbsp; <span class="text-7gpx font-normal leading-5 tracking-tighter text-title-default">in {{countdownFormattedValue}} </span>                    
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="form-group mb-0">
                                <button 
                                    class="mb-5 bg-primary h-21 items-center justify-center text-white flex w-full text-7gpx font-body-semibold rounded-gt-md-3"
                                    type="submit">
                                    Continue
                                </button>
                                <div class="flex w-full justify-end font-body">
                                    <a  (click)="displayDefaultTemplate = true"
                                        class="text-primary text-7gpx font-semibold font-body-semibold cursor-pointer">
                                        I can't access my number
                                    </a>
                                </div>
                              </div>
                        </form>
                    </div>
                </div>
           </div>
        </ng-template>
        <ng-template #displayTemplate>
            <div class="flex flex-col items-center" *ngIf="(!!!resetSuccessResponse.alternateMobileNo && !!!resetSuccessResponse.alternateEmail) || displayDefaultTemplate ||  !resetSuccessResponse?.alumniPortalEnabled">
                <div class="gt-contact-hr"></div>
                <div class="mt-5 flex">
                    <div class="flex flex-col p-5 rounded-gt-md-4 w-185 h-auto bg-std-success">
                        <div class="opacity-90 text-7gpx text-text-default font-body mb-9">
                            Please contact your HR to enable access to the Alumni portal.
                        </div>                
                        <div class="flex w-full justify-start font-body">
                            <a  (click)="goToLogin()"
                                class="text-primary text-7gpx font-semibold font-body-semibold cursor-pointer">
                                Back to Login 
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </section>
</section>
